import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const changeMotorTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_MOTOR_TEXT_FILTER,
  'payload': value,
});

export const changeBrandTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_BRAND_TEXT_FILTER,
  'payload': value,
});

export const changeOriginTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_ORIGIN_TEXT_FILTER,
  'payload': value,
});

export const fetchAnalysisList = (parameters, limit = 20, page = 0) => {
  const itemsCount = `&limit=${limit}`;
  const offset = `&offset=${page * limit}`;
  const code = parameters.code ? `&code=${parameters.code}` : '';
  const description = parameters.name ? `&name=${parameters.name}` : '';
  const motor = parameters.motor ? `&motor=${parameters.motor}` : '';
  const brand = parameters.brand ? `&brand=${parameters.brand}` : '';
  const origin = parameters.origin ? `&origin=${parameters.origin}` : '';
  const allFilters = `${code}${description}${motor}${brand}${origin}${itemsCount}${offset}`;

  return apiActionCreator({
    'endpoint': `/parts/analysis?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ANALYSIS_LIST,
      ActionTypes.FETCHED_ANALYSIS_LIST,
      [
        ActionTypes.FETCHED_ANALYSIS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchAnalysis = (code) => apiActionCreator({
  'endpoint': `/parts/analysis/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ANALYSIS,
    ActionTypes.FETCHED_ANALYSIS,
    [
      ActionTypes.FETCHED_ANALYSIS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const editAnalysis = (code, data) => apiActionCreator({
  'endpoint': `/parts/analysis/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVING_ANALYSIS,
    [
      ActionTypes.SAVED_ANALYSIS,
      MessageActions.addMessageBoxInfo('Repuesto actualizado satisfactoriamente'),
    ],
    [
      ActionTypes.SAVED_ANALYSIS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': data,
});

export const getPartWeeklyMoves = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/weekly-moves`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PART_WEEKLY_MOVES_REQUEST,
    ActionTypes.GET_PART_WEEKLY_MOVES_SUCCESS,
    [
      ActionTypes.GET_PART_WEEKLY_MOVES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchWeeklyAnalysis = (code, type, week) => apiActionCreator({
  'endpoint': `/parts/analysis/${code}/weekdata?type=${type}&week=${week}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WEEKLY_ANALYSIS,
    ActionTypes.FETCHED_WEEKLY_ANALYSIS,
    [
      ActionTypes.FETCHED_WEEKLY_ANALYSIS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

// modals
export const fetchTdeStockDetail = (code) => apiActionCreator({
  'endpoint': `/parts/analysis/${code}/tde-stock`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_TDE_STOCK_DETAIL,
    ActionTypes.FETCHED_TDE_STOCK_DETAIL,
    [
      ActionTypes.FETCHED_TDE_STOCK_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
